document.addEventListener('DOMContentLoaded', function () {
  const warmthGuide = document.querySelector('[data-warmth-guide]');

  if (!warmthGuide) {
    return;
  }

  const trigger = warmthGuide.querySelector('[data-warmth-guide-trigger]');
  const drawer = warmthGuide.querySelector('[data-warmth-guide-drawer]');
  const overlay = warmthGuide.querySelector('[data-warmth-guide-overlay]');
  const closeButton = warmthGuide.querySelector('[data-warmth-guide-close]');

  if (!trigger || !drawer || !overlay) {
    return;
  }

  function openDrawer() {
    drawer.hidden = false;
    overlay.hidden = false;

    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');

    window.setTimeout(function () {
      drawer.hidden = true;
      overlay.hidden = true;
    }, 350);
  }

  trigger.addEventListener('click', openDrawer);

  if (closeButton) {
    closeButton.addEventListener('click', closeDrawer);
  }

  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      drawer.classList.contains('is-open')
    ) {
      closeDrawer();
    }
  });
});